module.exports = __webpack_public_path__ + "static/media/1.7866a18e.jpg";